"use strict";
'kiwi public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _lodash = _interopRequireDefault(require("lodash"));
var _ThemeManager = _interopRequireDefault(require("@/libs/ThemeManager"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _localesList = _interopRequireDefault(require("@/res/localesList"));
var _SettingsAliases = _interopRequireDefault(require("./SettingsAliases"));
var _SettingsAdvanced = _interopRequireDefault(require("./SettingsAdvanced"));
/**
 * Returns an object for a vuejs computated property on a state settings value
 * This allows default settings from the server config, but overrides with user config
 */
function bindSetting(settingName) {
  return {
    get() {
      return this.$state.setting(settingName);
    },
    set(newVal) {
      this.$state.setting(settingName, newVal);
    }
  };
}
var _default = exports.default = {
  components: {
    SettingsAliases: _SettingsAliases.default,
    SettingsAdvanced: _SettingsAdvanced.default
  },
  data() {
    return {
      theme: '',
      customThemeUrl: '',
      pluginUiElements: _GlobalApi.default.singleton().appSettingsPlugins,
      localesList: _localesList.default
    };
  },
  computed: {
    themeSupportsMonospace() {
      let themeMgr = _ThemeManager.default.instance();
      let val = themeMgr.themeVar('supports-monospace');
      return val === '1';
    },
    canRegisterProtocolHandler() {
      return !!navigator.registerProtocolHandler && this.$state.setting('allowRegisterProtocolHandler');
    },
    timestamps_24h: {
      get() {
        // %H is 24 hour format
        return this.$state.setting('buffers.timestamp_format').substr(0, 2) === '%H';
      },
      set(newVal) {
        let newFormat = newVal ? '%H:%M:%S' : '%l:%M:%S %p';
        this.$state.setting('buffers.timestamp_format', newFormat);
      }
    },
    settings() {
      return this.$state.settings;
    },
    settingShowAutoComplete: bindSetting('showAutocomplete'),
    settingUseMonospace: bindSetting('useMonospace'),
    settingHighlights: bindSetting('highlights'),
    settingBufferColourNicknames: bindSetting('buffers.colour_nicknames_in_messages'),
    settingBufferShowTimestamps: bindSetting('buffers.show_timestamps'),
    settingBufferShowEmoticons: bindSetting('buffers.show_emoticons'),
    settingBufferBlockPms: bindSetting('buffers.block_pms'),
    settingBufferScrollbackSize: bindSetting('buffers.scrollback_size'),
    settingBufferExtraFormatting: bindSetting('buffers.extra_formatting'),
    settingBufferTrafficAsActivity: bindSetting('buffers.traffic_as_activity'),
    settingBufferMuteSound: bindSetting('buffers.mute_sound'),
    settingBufferShareTyping: bindSetting('buffers.share_typing'),
    settingDefaultBanMask: bindSetting('buffers.default_ban_mask'),
    settingDefaultKickReason: bindSetting('buffers.default_kick_reason'),
    settingBufferInlineLinkPreviews: {
      get() {
        // Display checkbox state based on channel preview setting
        // Setting it will update both channel and query settings
        return this.$state.setting('buffers.inline_link_auto_previews');
      },
      set(newVal) {
        this.$state.setting('buffers.inline_link_auto_previews', newVal);
        this.$state.setting('buffers.inline_link_auto_previews_query', newVal);
      }
    },
    settingAdvancedEnable: {
      get() {
        return this.$state.ui.show_advanced_tab;
      },
      set(newVal) {
        this.$state.ui.show_advanced_tab = newVal;
      }
    },
    settingLanguage: {
      get() {
        return this.$state.setting('language') || '';
      },
      set(newVal) {
        this.$state.setting('language', newVal || null);
      }
    },
    messageLayouts() {
      return {
        traditional: 'compact',
        modern: 'modern',
        inline: 'inline'
      };
    },
    settingMessageLayout: {
      get() {
        let s = this.$state.setting('buffers.messageLayout');
        let l = _lodash.default.invert(this.messageLayouts);
        return l[s];
      },
      set(newVal) {
        let l = this.messageLayouts;
        this.$state.setting('buffers.messageLayout', l[newVal] || l.modern);
      }
    }
  },
  created() {
    this.listenForThemeSettings();
    this.listen(this.$state, 'settings.tab.show', tabName => {
      this.showTab(tabName);
    });
  },
  methods: {
    closeSettings() {
      this.$state.$emit('active.component');
    },
    refreshTheme() {
      _ThemeManager.default.instance().reload();
    },
    showTab(tabName) {
      this.$refs.tabs.setActiveByName(tabName);
    },
    listenForThemeSettings() {
      let themeMgr = _ThemeManager.default.instance();
      let watches = [];

      // Called when the current theme changes (including url refreshes)
      let updateFn = () => {
        let theme = themeMgr.currentTheme();
        this.theme = theme.name;
        this.customThemeUrl = theme.name.toLowerCase() === 'custom' ? theme.url : '';
      };
      let failedFn = () => {
        if (this.theme.toLowerCase() !== 'custom') {
          let theme = themeMgr.currentTheme();
          this.theme = theme.name;
        }
      };
      let watchTheme = newVal => {
        if (newVal.toLowerCase() !== 'custom') {
          themeMgr.setTheme(newVal);
        }
      };
      let watchCustomThemeUrl = _lodash.default.debounce(newVal => {
        if (this.theme.toLowerCase() === 'custom') {
          themeMgr.setCustomThemeUrl(newVal);
        }
      }, 800, {
        leading: false,
        trailing: true
      });

      // Remove all our attached events to cleanup
      let teardownFn = () => {
        this.$state.$off('theme.change', updateFn);
        this.$state.$off('theme.failed', failedFn);
        watches.forEach(unwatchFn => unwatchFn());
        this.$off('hook:destroy', teardownFn);
      };

      // Update our info with the latest theme settings before we start
      // listening for changes
      updateFn();
      this.$state.$on('theme.change', updateFn);
      this.$state.$on('theme.failed', failedFn);
      this.$once('hook:destroyed', teardownFn);

      // $watch returns a function to stop watching the data field. Add them into
      // an array to make it easier to iterate over them all and unwatch them all
      // when needed.
      watches = [this.$watch('theme', watchTheme), this.$watch('customThemeUrl', watchCustomThemeUrl)];
    },
    enableAdvancedTab() {
      this.settingAdvancedEnable = true;
      this.$nextTick(() => {
        this.showTab('advanced');
        this.$el.scrollTop = 0;
      });
    },
    makeDefaultProtocolHandler() {
      const {
        origin,
        pathname
      } = document.location;
      navigator.registerProtocolHandler('irc', origin + pathname + '#%s', 'Kiwi IRC');
      navigator.registerProtocolHandler('ircs', origin + pathname + '#%s', 'Kiwi IRC');
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
window._kiwi_exports["components"]["AppSettings"]
window._kiwi_exports.components.AppSettings = exports.default ? exports.default : exports;
